<template>


  <!-- =======================
Main banner START -->
<section class="pt-0">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <!-- Card item START -->
          <div
            class="card overflow-hidden h-100px h-xl-200px rounded-3"
            style="
              background-image: url(/assets/images/bg/fondo-acercade-viaverde.jpg);
              background-position: center left;
              background-size: cover;
            "
          >
            <!-- Background dark overlay -->
            <div class="bg-overlay bg-dark opacity-6"></div>

            <!-- Card image overlay -->
            <div class="card-img-overlay d-flex align-items-start flex-column">
              <!-- Card overlay Top -->
              <!-- <div class="w-100 mb-auto d-flex justify-content-end">
							<button class="btn btn-sm btn-white mb-0"><i class="bi bi-share"></i> Share</button>
						</div> -->
              <!-- Card overlay bottom -->
              <div class="w-100 mt-auto">
                <div class="row p-0 p-sm-3">
                  <div class="col-11 col-lg-7">
                    <!-- Title -->
                    <!-- <h1 class="text-white">¿Preparado para exportar? responde al Diagnóstico</h1>
									<p class="text-white mb-0">Una forma efectiva de ver que capacidades falta desarrollar es respondiendo al Diagnóstico.</p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Card item END -->
        </div>
      </div>
    </div>
  </section>
  <!-- =======================
Main banner END -->

<div class="container seccion-1">
    <div class="row">
      <div class="col-md-8 contenido">
        <h3 class="mb-4">SOLICITANTE PRINCIPAL</h3>

        <h2>Instituto Boliviano de Comercio Exterior (IBCE)</h2>

        <p class="mt-4">
          El Instituto Boliviano de Comercio Exterior (IBCE) es una institución técnica-empresarial privada sin fines de lucro, creada en 1986 con la misión de promover el desarrollo productivo del país mediante la consolidación del comercio exterior como herramienta para el crecimiento económico, la generación de empleo y el acceso a mercados internacionales. A lo largo de casi cuatro décadas, el IBCE se ha consolidado como el principal referente nacional en temas de comercio exterior, competitividad, sostenibilidad y desarrollo empresarial, actuando como un articulador estratégico entre el sector público, privado y la cooperación internacional.
        </p>
      </div>

      <div class="col-md-4 imagen">
        <img
          src="assets/images/ibce-normal.jpg"
          alt="log IBCE"
          title="IBCE"
          class="img-fluid img-tablet img-responsive logo-ibce"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h4 class="mt-1">Trayectoria</h4>

        <p>
         Su trayectoria está respaldada por un amplio portafolio de servicios que incluyen estudios de mercado, asesoría en normativas de comercio internacional, análisis estadístico, organización de seminarios, talleres, misiones empresariales y campañas de sensibilización. Asimismo, ha liderado procesos de transformación productiva sostenible, apoyando a empresas bolivianas en la adopción de prácticas responsables en lo ambiental, económico y social. En el ámbito de la comunicación estratégica, el IBCE ha desarrollado productos especializados informativos digitales y físicos que se difunden anualmente a más de 1,2 millones de usuarios, además que la credibilidad que ha alcanzado el IBCE con la entrega de información especializada ha provocado un crecimiento verdaderamente exponencial de su visibilización, alcanzando un “pico” en la gestión 2018 con más de 34.000 apariciones de la institución por la prensa nacional e internacional, escrita y oral y vía Internet (monitoreo de noticias en medios de prensa orales y escritos, además de sitios web y blogs), atribuyéndose ello a la abundante producción y difusión de información especializada, así como a los análisis técnicos que realiza.. <br /><br />
          En el contexto del presente proyecto, el IBCE lidera la coordinación general, aportando su capacidad técnica en investigación de mercados, digitalización, sostenibilidad y formación empresarial. Su papel central estará enfocado en el desarrollo de la Plataforma digital para el diagnóstico exportador y sostenible de MiPymes, su fortalecimiento de capacidades, la identificación de casos de éxito, campañas de sensibilización, y la articulación de vínculos comerciales con el mercado europeo, principalmente. Gracias a su reputación, legitimidad institucional y presencia nacional, el IBCE garantiza una ejecución eficiente, transparente y orientada a resultados, contribuyendo directamente a los objetivos del programa AL-INVEST Verde y a la internacionalización del sector agroforestal boliviano bajo criterios de sostenibilidad y cumplimiento normativo.
          
        </p>
      </div>
    </div>
  </div>

  <div class="container seccion-1">
    <div class="row">
      <div class="col-md-8 contenido">
        <h3 class="mb-4">CO-SOLICITANTE</h3>

        <h2>Cámara de Comercio e Industria Boliviano-Alemana (AHK Bolivia)</h2>

        <p class="mt-4">

          La Cámara de Comercio e Industria Boliviano-Alemana (AHK Bolivia) es una institución binacional con amplia trayectoria en el fortalecimiento de las relaciones económicas, comerciales y de cooperación técnica entre Bolivia y Alemania. Fundada como parte de la red internacional de Cámaras Alemanas de Comercio Exterior (AHK) bajo el paraguas del Deutscher Industrie- und Handelskammertag (DIHK) -organismo con sede en Berlín- y donde la AHK Bolivia actúa como nexo directo entre el tejido empresarial boliviano y el ecosistema económico alemán, facilitando el acceso a mercados, el intercambio de conocimientos y la creación de alianzas estratégicas.
      
       
          
        </p>
      </div>

      <div class="col-md-4 imagen">
        <img
          src="assets/images/logo-ahk.png"
          alt="Cámara Boliviano-Alemana"
          title="Cámara Boliviano-Alemana"
          class="img-fluid img-tablet img-responsive logo-fagri"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">

        <p>
           Desde su apertura, la AHK Bolivia ha acompañado el proceso de internacionalización de cientos de empresas bolivianas, brindando servicios y soluciones especializados, gestión de eventos y relacionamiento de negocios B2B, principalmente. Gracias a su posicionamiento privilegiado en la red global de más de 130 Cámaras Binacionales presentes en más de 90 países, la institución cuenta con acceso directo a fuentes estratégicas de información, vínculos institucionales y contactos comerciales que fortalecen la integración de Bolivia con la economía europea.
        <br><br>
        En el marco del presente Proyecto, la AHK Bolivia aporta su conocimiento técnico en normativas internacionales, sostenibilidad, red de contactos y apertura de mercados para productos (agroforestales principalmente para el Proyecto). Su experiencia comprobada en la articulación de cadenas de valor sostenibles, junto a su capacidad para generar puentes institucionales y empresariales entre Europa y América Latina, la convierten en un aliado clave para la identificación de oportunidades comerciales, la transferencia de buenas prácticas y la promoción de la internacionalización de MiPymes bolivianas bajo criterios ambientales, sociales y comerciales de alto nivel.
        </p>

        
      </div>
    </div>
  </div>

  

  <div class="container seccion-1 mb-6">
    <div class="row">
      <div class="col-md-8 contenido">
        <h3 class="mb-4">CO-SOLICITANTE</h3>

        <h2>Fundación para el Desarrollo Forestal (FUNDEFOREST)</h2>

        <p class="mt-4">
          La Fundación para el Desarrollo Forestal (FUNDEFOREST) es una entidad civil sin fines de lucro, creada el 16 de agosto del año 2005 bajo lineamientos de la Cámara Forestal de Bolivia (CFB), con el propósito de promover el desarrollo sostenible del sector forestal en el país. A lo largo de más de dos décadas, ha consolidado su posición como una institución especializada en la gestión forestal integral, conservación de bosques, uso sostenible de los recursos naturales y fortalecimiento de capacidades técnicas y académicas del sector productivo vinculado a los ecosistemas forestales.
        </p>
      </div>

      <div class="col-md-4 imagen">
        <img
          src="assets/images/Logo-Fundeforest.png"
          alt="Fundación para el Desarrollo (FUNDEFOREST)"
          title="Fundación para el Desarrollo (FUNDEFOREST)"
          class="img-fluid img-tablet img-responsive logo-fundeforest"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">

        <p>FUNDEFOREST orienta su accionar a través de una estrategia basada en cinco principios fundamentales: la protección y conservación de los bosques, la promoción del uso sostenible e integral de los recursos forestales, el fomento a la capacitación técnica y académica de los productores, la articulación con actores públicos y privados bajo un enfoque de biodiversidad e inclusión, y la modernización tecnológica de la industria forestal mediante procesos de reconversión industrial. 
<br><br>
          En el marco del presente Proyecto, FUNDEFOREST desempeña un rol clave en el acompañamiento técnico a las MiPymes del sector agroforestal, aportando con su conocimiento profundo de la realidad productiva forestal boliviana, su experiencia, su red de alianzas con comunidades productoras, y su capacidad para articular procesos de transformación productiva bajo criterios ambientales y sociales. Su contribución será esencial para asegurar que las prácticas implementadas por las empresas estén alineadas con los estándares de sostenibilidad exigidos por el mercado europeo, fomentando cadenas de valor que promuevan la conservación de los bosques, la trazabilidad y la inclusión productiva rural.

        </p>
        
      </div>
    </div>
  </div>
    <FloatingActionButton :categoryNames="categoryNames" />
</template>

<script>
import {ref } from "vue";
import FloatingActionButton from "@/modules/common/components/FloatingActionButton.vue";
export default {
  components: {
    FloatingActionButton,
  },
  setup() {
    //Categoria a mostrar para FAQS
    const categoryNames = ref(["Sobre el Consorcio"]);

    return {
      categoryNames,
    };
  },
};
</script>

<style scoped>

h1 {
  font-family: "Merriweather" !important;
  font-weight: 900;
  font-size: 28px;
}
h2 {
  font-family: "Merriweather" !important;
  font-weight: 600;
}
h3,h4,h5{
  font-family: "Merriweather" !important;
}
p,span,li,a{
  font-family: "Montserrat" !important;
}
p,a,span,li{
  font-size: 18px;
}

h1 {
  font-family: "Merriweather" !important;
  font-weight: 900;
}

.seccion-1 {
  margin-top: 3rem;
}
.seccion-1 h3 {
  color: #009644;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 4px;
  font-family: "Montserrat";
}

.seccion-1 p {
  text-align: justify;
}
.seccion-1 .logo-fagri,
.seccion-1 .logo-ibce {
  width: 100%;
  margin-top: 50px;
}
.seccion-1 .logo-fundeforest {
  width: 300px;
  margin-top: 50px;
}
.seccion-1 .imagen {
  text-align: center;
  width: 370px;
}

@media (max-width: 765px) {
  .seccion-1 {
    margin-top: 3rem !important;
  }
}
</style>
